// removed by extract-text-webpack-plugin
module.exports = {"StaticMap":"src-components-Footer----StaticMap-module---StaticMap---2QBzW","map":"src-components-Footer----StaticMap-module---map---3-MQU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/StaticMap.module.css
// module id = 376
// module chunks = 114276838955818